import { render, staticRenderFns } from "./CwcIcon.vue?vue&type=template&id=39cc87a7"
import script from "./CwcIcon.vue?vue&type=script&lang=js"
export * from "./CwcIcon.vue?vue&type=script&lang=js"
import style0 from "./CwcIcon.vue?vue&type=style&index=0&id=39cc87a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports